import { spacing } from '@upstox/upstox-ui';

export const item: CSSFunction = ({ theme, cssProps: { isSeoApp } }) => ({
  flexBasis: isSeoApp ? '50%' : '33%',
  flexDirection: isSeoApp ? 'column' : 'column-reverse',
  '@media (min-width:991px)': {
    flexBasis: '25%',
  },
  '@media (min-width:1024px)': {
    flexBasis: '23%',
    flexDirection: 'column',
  },
  '&:not(last-child)': {
    marginBottom: spacing(theme, [18]),
    '@media (min-width:768px)': {
      marginBottom: spacing(theme, ['large']),
    },
  },
});

export const label: CSSFunction = ({ theme }) => ({
  marginBottom: spacing(theme, ['none']),
  '@media (min-width:768px)': {
    marginBottom: spacing(theme, [3]),
  },
});
